module.exports = __webpack_public_path__ + "static/media/tab_og.940da6e7.png";